exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "a[data-v-6ec31992]{color:inherit;text-decoration:none;cursor:pointer!important;pointer-events:all;-webkit-user-select:none;user-select:none;-webkit-touch-callout:none}p[data-v-6ec31992]{margin-bottom:12px}ol[data-v-6ec31992]{list-style:inside}.Related[data-v-6ec31992]{width:100%;margin:0 0 112px;display:flex;left:0}@media (max-width:440px){.Related[data-v-6ec31992]{margin:0 0 48px;flex-flow:column}}.Related-button[data-v-6ec31992]{width:340px;height:80px;margin-right:15px}@media (max-width:440px){.Related-button[data-v-6ec31992]{width:100%;margin-right:0;margin-bottom:15px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?minimize!../node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6ec31992","scoped":true,"hasInlineConfig":false}!../node_modules/sass-loader/lib/loader.js?indentedSyntax!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/blocks/Related.vue
// module id = 438
// module chunks = 0